import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import TopBar from '../DashboardLayout/TopBar';
import NavBar from '../DashboardLayout/NavBar';
import NotificationBar from '../DashboardLayout/NotificationBar';



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    [theme.breakpoints.up('lg')]: {
      margin: '0 -10px'
    }
  }
}));

const MainLayout = () => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [isNotiOpen, setNotiOpen] = useState(false);

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} onNotiPanelOpen={() => setNotiOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <NotificationBar
        onNotificationClose={() => setNotiOpen(false)}
        openNotification={isNotiOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;